interface LogoProps {
  variant?: "color" | "white";
  className?: string;
  height?: number;
}

export function Logo({ variant = "color", className, height = 32 }: LogoProps) {
  const navy = variant === "white" ? "#ffffff" : "#14495A";
  const coral = "#E94B3F";
  return (
    <svg
      role="img"
      aria-label="Power Coaching"
      viewBox="0 0 440 60"
      height={height}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Power Coaching</title>
      <g
        fontFamily="Inter, system-ui, sans-serif"
        fontWeight="800"
        fontSize="44"
        letterSpacing="0.5"
      >
        <text x="0" y="46" fill={navy}>
          P
        </text>
        <text x="76" y="46" fill={navy}>
          WER
        </text>
        <text x="200" y="46" fill={navy}>
          COACHING
        </text>
      </g>
      {/* Lightning bolt replacing the O of POWER, visually centered between P and W */}
      <g transform="translate(32, 8)">
        <circle
          cx="20"
          cy="22"
          r="22"
          fill="none"
          stroke={coral}
          strokeWidth="3"
        />
        <path
          d="M26 4 L10 24 L20 24 L14 42 L32 20 L22 20 L26 4 Z"
          fill={coral}
          stroke={coral}
          strokeWidth="0.5"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export function LogoMark({
  className,
  size = 40,
}: {
  className?: string;
  size?: number;
}) {
  return (
    <svg
      role="img"
      aria-label="Power Coaching mark"
      viewBox="0 0 56 56"
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="28" cy="28" r="26" fill="#14495A" />
      <path
        d="M32 12 L14 34 L24 34 L20 46 L40 24 L30 24 L32 12 Z"
        fill="#E94B3F"
        stroke="#E94B3F"
        strokeWidth="0.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}
